import React, { useState } from 'react'
import { nanoid } from '@reduxjs/toolkit'
import { useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { updateRoom } from '../slices/roomSlice'
import Loading from './Loading'

export default function MultiPlayer() {

    let [open, setOpen] = useState(false)
    let [error, setError] = useState(false)
    let [error1, setError1] = useState(false)
    let [roomId, setRoomId] = useState('')
    let { socket, userId } = useSelector(state => state.userSlice)
    let goTo = useNavigate()
    let dispatch = useDispatch()

    let joinRoom = () => {
        setOpen(false)
        socket.emit('joinRoom', { roomId, userId })
    }

    socket.on('getCreatorData', async (data) => {
        await dispatch(updateRoom(data))
        goTo(`/play/multi-player-game/${roomId}`)
    })

    socket.on('error', () => { setError(true) })
    socket.on('error1', () => { setError1(true) })

    let createRoom = () => {
        let roomId = nanoid(12)
        goTo(`/play/multi-player-game/${roomId}`)
    }

    return (
        <div className="MultiPlayer">
            {(userId === null || socket === null) ?
                (<Loading />)
                :
                (<div className="btn-div">
                    <button className="home-button" onClick={() => createRoom()}>Create Room</button>
                    <button className="home-button" onClick={() => setOpen(true)} >Join Room</button>
                </div>)
            }

            {open && <div className="join-room">
                <div className="join-room-div">
                    <div className="input-div">
                        <label htmlFor="roomId">Enter Room ID : </label>
                        <input type="text" name="roomId" value={roomId} onChange={(e) => setRoomId(e.target.value)} />
                    </div>
                    <button className="join-btn" onClick={() => joinRoom()}>Join</button>
                </div>
            </div>}

            {error && <div className="join-room">
                <div className="join-room-div">
                    <div className="input-div">
                        <label htmlFor="roomId">This room is already full, Please create another room.</label></div>
                    <button className="join-btn" onClick={() => setError(false)}>Go Back</button>
                </div>
            </div>}

            {error1 && <div className="join-room">
                <div className="join-room-div">
                    <div className="input-div">
                        <label htmlFor="roomId">You have entered a wrong room id.</label></div>
                    <button className="join-btn" onClick={() => setError1(false)}>Go Back</button>
                </div>
            </div>}
        </div>
    )
}
